module.exports = __webpack_public_path__ + "lp/img/arrow_down.31d68834.svg";